const singleDirectionOdds = ["1L", "1R", "3L", "3R", "5L", "5R", "7L", "7R"];

export default singleDirectionOdds